import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { clearStoredAuth, getAuthState, resolveAdminAccess, verifyAdminAccess } from '../utils/auth';

export default function AdminRoute({ children }) {
  const location = useLocation();
  const { authenticated, isAdmin, token } = getAuthState();
  const [status, setStatus] = useState(authenticated ? 'checking' : 'unauthenticated');

  useEffect(() => {
    let cancelled = false;

    if (!authenticated) {
      clearStoredAuth();
      setStatus('unauthenticated');
      return undefined;
    }

    setStatus('checking');

    verifyAdminAccess(token).then((result) => {
      if (cancelled) {
        return;
      }

      const nextStatus = resolveAdminAccess({ authenticated, isAdmin, token }, result);
      if (nextStatus === 'unauthenticated') {
        clearStoredAuth();
      }
      setStatus(nextStatus);
    });

    return () => {
      cancelled = true;
    };
  }, [authenticated, isAdmin, token]);

  if (status === 'unauthenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (status === 'forbidden') {
    return <Navigate to="/dashboard" replace />;
  }

  if (status !== 'authorized') {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: '2rem' }}>
        <p>Verificando permisos de administrador...</p>
      </div>
    );
  }

  return children;
}